import { Pipe, PipeTransform } from '@angular/core';
import { FieldDefinition } from '@wdx/shared/utils';
import { Observable } from 'rxjs';
import { FormSummaryValueOptions } from '../../models/form-summary-value.model';
import { FormSummaryService } from '../../services/form-summary/form-summary.service';

@Pipe({ name: 'formSummaryValue' })
export class FormSummaryValuePipe implements PipeTransform {
    constructor(private formSummaryService: FormSummaryService) {}

    transform(
        value: string,
        fieldDefinition: FieldDefinition,
        formSchema?: FieldDefinition[],
        options?: FormSummaryValueOptions,
        parentData?: any,
    ): Observable<string> {
        return this.formSummaryService.getStringValue(
            value,
            fieldDefinition,
            options,
            parentData,
            formSchema,
        ) as Observable<string>;
    }
}
